export enum ActionTypes {
  LINKEDIN = 'LINKEDIN',
  MESSAGE = 'MESSAGE',
  SAVE = 'SAVE',
  SHARE = 'SHARE',
  VIEW = 'VIEW',
}
